import './Filter.scss';
import './JobActivityFilter.scss';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import React, { useState } from 'react';
import { useQuery } from '@apollo/client/react';
import { useStoreContext } from '../App/StoreProvider';
import {
    GET_ALL_LOFAS,
    GET_ALL_JOBS_FILTER,
    GET_ALL_CARRIERS_FILTER,
    GET_ALL_REGIONS,
    GET_ALL_PROPPANTS,
    GET_ALL_DRIVERS_FILTER,
    GET_JOB_FILTERS_LIST,
} from '../../graphql/client/queries';
import {
    GetAllLofas,
    GetJobFiltersList,
    GetAllJobsFilter,
    GetAllCarriersFilter,
    GetAllDriversFilter,
    GetAllRegions,
    GetAllProppants,
} from '../../types/schemaTypes';
import LoadFilterItem from './FilterItem/LoadFilterItem';
import Button from 'react-bootstrap/Button';
import oilWellIcon from '../../assets/oilWell.png';
import lofaIcon from '../../assets/lofaIcon.png';
import redTruckIcon from '../../assets/redTruck.png';
import whiteTruckIcon from '../../assets/whiteTruck.png';
import blueTruckIcon from '../../assets/blueTruck.png';
import tealTruckIcon from '../../assets/tealTruck.png';
import orangeTruckIcon from '../../assets/orangeTruck.png';
import greenTruckIcon from '../../assets/greenTruck.png';

interface DashboardFiltersProps {
    abortRequest: () => void;
    onFilterToggle: () => void;
}

export const DashboardFilters = ({ abortRequest, onFilterToggle }: DashboardFiltersProps): React.ReactElement => {
    const [activeKey, setActiveKey] = useState('0');
    const [state] = useStoreContext();

    const { data: lofasData } = useQuery<GetAllLofas>(GET_ALL_LOFAS);
    const { data: jobData } = useQuery<GetAllJobsFilter>(GET_ALL_JOBS_FILTER);
    const { data: carriersData } = useQuery<GetAllCarriersFilter>(GET_ALL_CARRIERS_FILTER);
    const { data: regionsData } = useQuery<GetAllRegions>(GET_ALL_REGIONS);
    const { data: proppantsData } = useQuery<GetAllProppants>(GET_ALL_PROPPANTS);
    const { data: driversData } = useQuery<GetAllDriversFilter>(GET_ALL_DRIVERS_FILTER);
    const { data: jobFiltersData } = useQuery<GetJobFiltersList>(GET_JOB_FILTERS_LIST);

    const lofaFilters: any = [];
    let allJobsFilters: any = [];
    let carrierFilters: any = [];
    const regionFilters: any = [];
    const proppants: any = [];
    let driverFilters: any[] = [];
    let customerFilters: any = [];
    const statuses: any = [
        {
            id: 'Assigned',
            name: 'Assigned',
        },
        {
            id: 'Loading',
            name: 'Loading',
        },
        {
            id: 'Loaded',
            name: 'Loaded',
        },
        {
            id: 'On-site',
            name: 'On-site',
        },
    ];

    const {
        loadManagementList: {
            searchPhraseSubset: {
                lofaSubset,
                jobSubset,
                carrierSubset,
                regionSubset,
                proppantSubset,
                driverSubset,
                customerSubset,
                statusSubset,
            },
        },
    } = state;

    if (lofasData && lofasData.getAllLofas) {
        lofasData.getAllLofas.forEach((item: any) => {
            lofaFilters.push({
                id: item.lofaId,
                name: item.lofaName,
            });
        });
    }

    if (jobFiltersData && jobFiltersData.getJobFiltersList) {
        if (jobFiltersData.getJobFiltersList.customers) {
            customerFilters = jobFiltersData.getJobFiltersList.customers;
        }
    }

    if (jobData && jobData.getAllJobsFilter) {
        allJobsFilters = jobData.getAllJobsFilter;
    }

    if (carriersData && carriersData.getAllCarriersFilter) {
        carrierFilters = carriersData.getAllCarriersFilter;
    }

    if (driversData && driversData.getAllDriversFilter) {
        driverFilters = driversData.getAllDriversFilter;
    }

    if (regionsData && regionsData.getAllRegions) {
        regionsData.getAllRegions.forEach((item: any) => {
            regionFilters.push({
                id: item.id,
                name: item.regionName,
            });
        });
    }

    if (proppantsData && proppantsData.getAllProppants) {
        proppantsData.getAllProppants.forEach((item: any) => {
            proppants.push({
                id: item.proppantId,
                name: item.proppantName,
            });
        });
    }

    return (
        <div className="Filter-Container">
            <div>
                <Accordion>
                    <Card className="FilterItem-Card">
                        <Card.Body>
                            <table className="table-bordered">
                                {/* <thead>
                                    <tr>
                                        <th className="MapLegend-Header">Map Legend</th>
                                    </tr>
                                </thead> */}
                                <tbody>
                                    <tr>
                                        <td className="col-3">Well Site: </td>
                                        <td className="col-3">
                                            <img src={oilWellIcon} />
                                        </td>
                                        <td className="col-3">LOFA: </td>
                                        <td className="col-3">
                                            <img src={lofaIcon} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="col-3">Assigned:</td>
                                        <td className="col-3">
                                            <img src={blueTruckIcon} />
                                        </td>
                                        <td className="col-3">Loading:</td>
                                        <td className="col-3">
                                            <img src={tealTruckIcon} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="col-3">Loaded:</td>
                                        <td className="col-3">
                                            <img src={orangeTruckIcon} />
                                        </td>
                                        <td className="col-3">On-Site:</td>
                                        <td className="col-3">
                                            <img src={greenTruckIcon} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="col-3">Checked In:</td>
                                        <td className="col-3">
                                            <img src={whiteTruckIcon} />
                                        </td>
                                        <td className="col-3">Late:</td>
                                        <td className="col-3">
                                            <img src={redTruckIcon} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Card.Body>
                    </Card>
                </Accordion>
            </div>
            <div className="Filter-Header">
                <div className="Filter-HeaderIconContainer">
                    <i className="material-icons">filter_list</i>
                    <span className="Filter-HeaderTitle">Filters</span>
                </div>
                <Button
                    className="Filter-SelectAll"
                    variant="link"
                    onClick={(): void => setActiveKey(activeKey === '0' ? '1' : '0')}
                >
                    {activeKey === '0' ? 'Collapse All' : 'Expand All'}
                </Button>
            </div>
            <LoadFilterItem
                abortRequest={abortRequest}
                title="Load Status"
                items={statuses}
                itemsSubset={statusSubset.subset}
                searchPhrase={statusSubset.searchPhrase}
                activeKey={activeKey}
                isCollection={true}
                isSearchable={false}
                loadManagementMode={true}
                onFilterToggle={onFilterToggle}
            />
            <LoadFilterItem
                abortRequest={abortRequest}
                title="Region"
                items={regionFilters}
                itemsSubset={regionSubset.subset}
                searchPhrase={regionSubset.searchPhrase}
                activeKey={activeKey}
                isCollection={true}
                isSearchable={true}
                loadManagementMode={true}
                onFilterToggle={onFilterToggle}
            />
            <LoadFilterItem
                abortRequest={abortRequest}
                title="Job"
                items={allJobsFilters}
                itemsSubset={jobSubset.subset}
                searchPhrase={jobSubset.searchPhrase}
                activeKey={activeKey}
                isCollection={true}
                isSearchable={true}
                loadManagementMode={true}
                onFilterToggle={onFilterToggle}
            />
            <LoadFilterItem
                abortRequest={abortRequest}
                title="Loading Facility"
                items={lofaFilters}
                itemsSubset={lofaSubset.subset}
                searchPhrase={lofaSubset.searchPhrase}
                activeKey={activeKey}
                isCollection={true}
                isSearchable={true}
                loadManagementMode={true}
                onFilterToggle={onFilterToggle}
            />
            <LoadFilterItem
                abortRequest={abortRequest}
                title="Proppant"
                items={proppants}
                itemsSubset={proppantSubset.subset}
                searchPhrase={proppantSubset.searchPhrase}
                activeKey={activeKey}
                isCollection={true}
                isSearchable={true}
                loadManagementMode={true}
                onFilterToggle={onFilterToggle}
            />
            <LoadFilterItem
                abortRequest={abortRequest}
                title="Customer"
                items={customerFilters}
                itemsSubset={customerSubset.subset}
                searchPhrase={customerSubset.searchPhrase}
                activeKey={activeKey}
                isCollection={true}
                isSearchable={true}
                loadManagementMode={true}
                onFilterToggle={onFilterToggle}
            />
            <LoadFilterItem
                abortRequest={abortRequest}
                title="Driver"
                items={driverFilters}
                itemsSubset={driverSubset.subset}
                searchPhrase={driverSubset.searchPhrase}
                activeKey={activeKey}
                isCollection={true}
                isSearchable={true}
                loadManagementMode={true}
                onFilterToggle={onFilterToggle}
            />
            <LoadFilterItem
                abortRequest={abortRequest}
                title="Carrier"
                items={carrierFilters}
                itemsSubset={carrierSubset.subset}
                searchPhrase={carrierSubset.searchPhrase}
                activeKey={activeKey}
                isCollection={true}
                isSearchable={true}
                loadManagementMode={true}
                onFilterToggle={onFilterToggle}
            />
        </div>
    );
};
